<template>
  <div class='stat-editor'>
    <h2 v-if='title'>{{ title }}</h2>
    <div class="field-component">
      <label for="question">Question</label>
      <select @change='questionChange'>
        <option :selected='!stat' :value='null' key='selectQuestion'>Choose a question</option>
        <option :selected='stat && stat.question == question.value' v-if='shouldShowQuestion(question)' v-for='question in this.questionField.options' :key='question.value' :value="question.value" v-html='question.label'></option>
      </select>
    </div>
    <div class="field-component" v-if='selectAnswer && localStat.question'>
        <label>Answers</label>
        <div v-if='answerSelectionType == "checkbox"'>
          <div v-for='answerOption in this.answerField.options' :key='answerOption.value' class='answer-list' >
            <input :name='answerOption.label' :checked='localStat.answer.indexOf(answerOption.value) !== -1 ? "checked" : ""' type='checkbox' :value="answerOption.value" :id='answerOption.label' @change='onAnswerCheck(answerOption)'> <span>{{answerOption.label}} (Result: {{ resultFor(answerOption.value).percent | twoPointPercent }} )</span>
          </div>
        </div>
        <div v-if='answerSelectionType === "radio"'>
          <div v-for='answerOption in this.answerField.options' :key='answerOption.value' class='answer-list' >
            <input name='answer' type='radio' :value="answerOption.value" :checked='localStat.answer.indexOf(answerOption.value) !== -1' @change='onAnswerCheck(answerOption)' :id='answerOption.label'> <span>{{answerOption.label}} (Result: {{ resultFor(answerOption.value).percent | twoPointPercent }} )</span>
          </div>
        </div>
    </div>

    <div v-if='filterOpen'>
      <div class="field-component">
        <label for="question">Filter</label>
        <select @change='filterChange'>
          <option :selected='!localStat.filterQuestion' :value='null' key='selectFilterQuestion'>Choose a question</option>
          <option :selected='localStat.filterQuestion && localStat.filterQuestion == question.value' v-for='question in this.questionField.options' :key='question.value' :value="question.value">{{question.label}}</option>
        </select>
      </div>

      <div class="field-component" v-if='localStat.filterQuestion'>
        <label>Answers</label>
        <select @change='filterAnswerChange'>
          <option :selected='!localStat.filterAnswer' :value='null' key='selectFilterAnswer'>Choose an answer</option>
          <option :selected='localStat.filterAnswer && localStat.filterAnswer == answer.value' v-for='answer in filterAnswers' :key='answer.value' :value="answer.value">{{answer.label}}</option>
        </select>
      </div>
    </div>
    <a @click.prevent='addStat' class='button' v-if='Array.isArray(localStat.answer) && localStat.answer.length > 0' :disabled='!validQuery'><ion-icon name="add"></ion-icon><span class='add-action'>{{ addAction}}</span></a>
    <span v-if='localStat.answer'>
      <a @click.prevent='toggleFilter' class='button button-add-filter' v-if='!filterOpen && localStat.answer.length > 0'><ion-icon name="add"></ion-icon><span class='add-action'>Add Filter</span></a>
      <a @click.prevent='toggleFilter' class='button button-remove-filter' v-if='filterOpen'><ion-icon name="remove"></ion-icon><span class='add-action'>Remove Filter</span></a>
    </span>
  </div>

</template>
<script>
import Vue from 'vue'
import Field from '../../Field'
import Filters from '../../mixins/Filters'
import Utilities from '../../lib/Utilities'
import _ from 'lodash'
export default {
  props: {
    stat: {type: Object, default: function(){return {
      answer: [],
      question: null
    }}},
    report: {type: Object, default: ()=>({})},
    title: {type: String, default: 'Add a headline statistic'},
    selectAnswer: {type: Boolean, default: true},
    selectFormat: {type: Boolean, default: true}
  },
  mixins: [Filters],
  data () {
    return {
      localStat: {
        answer: [],
        question: null,
        filterQuestion: null,
        filterAnswer: null
      },
      format: 'percentage',
      questionField: {
        options: [],
        type: 'select'
      },
      answerField: {
        options: [],
        type: 'select',
        name: 'answer'
      },
      filterAnswers: [],
      filterOpen: false
    }
  },
  components: {
    Field
  },
  computed: {
    answerSelectionType () {
      let type = 'checkbox'
      if (this.questionType) {
        switch (this.questionType) {
          case 'MultiSelect':
            type = 'radio'
          break
          default:
            type = 'checkbox'
        }
      }
      return type
    },
    questionType () {
      if (_.isUndefined(this.report.schema)) {
        return false
      }
      let questionWithKey = Utilities.filterObjectArray(this.report.schema, 'key', this.localStat.question)
      if (questionWithKey.length === 0) {
        return false
      }
      return questionWithKey[0].type
    },
    isMultiSelect () {
      return this.questionType === 'MultiSelect'
    },
    addAction () {
      if (this.stat.valueText !== "") {
        return 'Update Stat'
      } else {
        return 'Add Stat'
      }
    },
    filterEnabled () {
      return this.stat && this.stat.filterQuestion || this.filterOpen
    },
    validQuery () {
      if (!this.localStat.question || this.localStat.answer.length === 0) {
        return false
      }
      if (this.localStat.filterQuestion && (!this.localStat.filterAnswer || this.localStat.filterAnswer === '')) {
        return false
      }
      return true
    }
  },
  methods: {
    shouldShowQuestion (question) {
      let disallowed = ['barrier']
      return disallowed.indexOf(question.value) === -1
    },
    toggleFilter () {
      this.filterOpen = !this.filterOpen
      if (!this.filterOpen) {
        this.localStat.filterQuestion = null
        this.localStat.filterAnswer = null
      }
    },
    onAnswerCheck (answer) {
      if (this.answerSelectionType === 'radio') {
        this.localStat.answer = [answer.value]
        return
      }
      let idx = this.localStat.answer.indexOf(answer.value)
      if (idx === -1) {
        this.localStat.answer.push(answer.value)
      } else {
        this.localStat.answer.splice(idx, 1)
      }
    },
    questionChange (event) {
      let question = event.target.selectedOptions[0].value
      this.localStat.question = question
      this.localStat.answer = []
      this.answerField.options = this.updateAnswers(this.localStat.question)
    },
    filterChange (event) {
      let question = event.target.selectedOptions[0].value
      this.localStat.filterQuestion = question;
      this.localStat.filterAnswer = null
      this.filterAnswers = this.updateAnswers(question)
    },
    filterAnswerChange (event) {
      let answer = event.target.selectedOptions[0].value
      this.localStat.filterAnswer = answer;
    },
    resultFor (answer) {

      return this.report.stats[this.localStat.question][answer]
    },
    answerLabel (answer) {
      if (this.getQuestionType() === 'checkbox') {
        return answer === true ? 'Yes' : 'No'
      }
      return answer
    },
    formatResult(format){
      let formatted = ''

      let result = this.resultFor(this.localStat.answer)
      switch (format) {
        case 'percentage':
          formatted = `${Math.round(result.percent*100)}%`
          break;
        case 'xiny':
          formatted = `${result.count} in ${result.total}`
          break;
        default:
          formatted = '---'
          break
      }
      return formatted
    },
    defaultText () {
      let orderedAnswers = []
      let answerText = ''
      let count = 0
      for (let answer of this.answerField.options) {
        if (this.localStat.answer.indexOf(answer.label) !== -1) {
          orderedAnswers.push(this.answerLabel(answer.label))
        }
      }
      if (orderedAnswers.length === 1 ) {
        answerText = orderedAnswers[0]
      } else {
        let lastAnswer = orderedAnswers.pop()
        answerText = orderedAnswers.join(', ') + ' or ' + lastAnswer
      }
      let filterText = ''
      if (this.localStat.filterQuestion) {
        filterText = ` and also answered <b>${this.localStat.filterAnswer}</b> when asked <b>${this.report.questions[this.localStat.filterQuestion]}</b>`
      }
      return `of respondents answered
       <span class='answer'>${answerText}</span> to the question
       <span class='question'>${this.report.questions[this.localStat.question]}</span>
       <span class='filter-text'>${filterText}</span>`
    },
    answerChange(event){
      this.localStat.answer = event.value
    },
    getQuestionType () {
      const key = this.localStat.question
      const storedSchema = this.$store.state.config.questionSchema
      const questionIndex = Utilities.getIndexOfObject(storedSchema, 'key', key)
      const questionSchema = storedSchema[questionIndex]
      const questionType = questionSchema.type
      return questionType
    },
    addStat () {
      if (!this.validQuery) {
        return
      }
      const questionType = this.getQuestionType()

      let query = {
        question: this.localStat.question,
        answer: this.localStat.answer,
        filterQuestion: this.localStat.filterQuestion,
        filterAnswer: [this.localStat.filterAnswer]
      }
      let payload = {
          answer: this.localStat.answer,
          type: questionType,
          questionText: this.report.questions[this.localStat.question],
          format: this.format,
          text: this.defaultText(),
          showValue: true,
          valueText: '',
          figureFontSize: null,
          captionFontSize: null,
          figureColor: null,
          captionColor: null,
          ...query
        }

      this.$store.dispatch('queryStat', query).then((resp)=>{
        payload.valueText = (parseFloat(resp.data.result.percent) * 100).toFixed() + '%'
        Vue.nextTick(()=>{
          this.$emit('add', JSON.parse(JSON.stringify(payload)))
        })
      }).catch((error)=>{
        console.log(error)
      })

      // TODO Slice the question list when this question is added
      //this.questionField.options.slice(idx, 1)
    },
    updateAnswers (questionKey) {
      let answers = []
      if (!questionKey) {
        return
      }
      for (let answer of this.report.answers[questionKey]){
        let option = {label: answer, value: answer}
        answers.push(option)
      }
      return answers
    }
  },
  created () {
    if (this.stat) {
      this.localStat = JSON.parse(JSON.stringify(this.stat))
    }
    for (let [key, value] of Object.entries(this.report.questions)) {
      let option = {label: value, value: key}
      this.questionField.options.push(option)
    }
    this.answerField.options = this.updateAnswers(this.localStat.question)
    if (this.localStat.filterQuestion) {
      this.filterAnswers = this.updateAnswers(this.localStat.filterQuestion)
      this.filterOpen = true;
    }
  },
  watch: {
    stat: {
      deep: true,
      handler: function (newStat) {
        if (!newStat) {
          this.localStat.answer = []
          this.localStat.question = null
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
@import '../../scss/mixins';
@import '../../report-editor/scss/main.scss';
  .stat-editor {
    ion-icon {
      color: white;
      font-size: 25px;
      vertical-align: middle;
    }
    select {
      max-width: 100%;
    }

    a.button {
      @include button;
      width: auto;
      margin: 1rem 0;
      display: inline-block;
      padding: 4px 18px 4px 10px;
      .add-action {
        vertical-align: -2px;
      }
      ion-icon {
        font-size: 20px;
      }
      &.button-add-filter {
        background-color: darken(#4DBCBA, 25%);
      }
      &.button-remove-filter {
        background-color: #111;
      }
      &[disabled='disabled'] {
        opacity: 0.3;
      }
    }
  }
</style>